<!--Account Search-->
<div style="margin-top: 8px; font-size: 15px; height: 75px; align-items: center">
  <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column; place-content: stretch space-between; align-items: stretch; gap: 20px;">
    <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: row">
      <div mat-line style="width:100%">
        <mat-form-field style="padding-left: 16px; padding-right: 16px; width: calc(100% - 32px);">
          <input matInput placeholder="Search Accounts" #searchBox id="search-box" (keyup)="updateSearchText(searchBox.value)" />
          <button mat-button id="clearSearch" *ngIf="searchBox.value" matSuffix aria-label="Clear" (click)="searchBox.value=''; updateSearchText(searchBox.value)">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>

<cdk-virtual-scroll-viewport #leftScroll itemSize="48" style="height:87%">
  <mat-action-list style="overflow: hidden;">

    <!--Account List-->
    <mat-list-item [attr.id]="'selectAccountId.'+account.accountId" *cdkVirtualFor="let account of accounts" [ngClass]="{'sidenav-selected-item': selectedAccount === account, 'sidenav-row-item': selectedAccount !== account}" (click)="selectAccount(account)">
      <div mat-line> {{account.accountName}} </div>
      <mat-divider></mat-divider>
    </mat-list-item>

  </mat-action-list>
</cdk-virtual-scroll-viewport>